import VendorSearchResultsHtml from '../../app-lite/vendors/templates/vendors.search.results.html';

export function PartsAuthoritySettingsCtrl (
  $state,
  $scope,
  $translate,
  confirm,
  integrations,
  messages,
  streamSearch,
  Vendor,
  workshopAPI
) {
  $scope.integrations = integrations;
  $scope.loaded       = true;

  $scope.save = function (form) {
    workshopAPI.patch('/company_integrations', $scope.integrations, 'company_integration').then(() => {
      messages.show($translate.instant('JS_SPACE.MESSAGES.SAVED.SAVE_SUCCESSFUL'), 'success');

      $state.reload();
    }).catch(err => {
      messages.error(err);
    });
  };

  $scope.activate = function () {
    confirm.generic($translate.instant('JS_SPACE.INTEGRATIONS.ACTIVATE', { name: 'Parts Authority' })).then(() => {
      return workshopAPI.get('/company_integration/add_parts_authority');
    }).then(() => {
      messages.show($translate.instant('JS_SPACE.INTEGRATIONS.ACTIVATED', { name: 'Parts Authority' }), 'success');

      $state.reload();
    }).catch(err => {
      messages.error(err);
    });
  };

  $scope.remove = function () {
    confirm.generic($translate.instant('JS_SPACE.INTEGRATIONS.REMOVE', { name: 'Parts Authority' })).then(() => {
      return workshopAPI.get('/company_integration/remove_parts_authority')
    }).then(() => {
      messages.show($translate.instant('JS_SPACE.INTEGRATIONS.REMOVED', { name: 'Parts Authority' }), 'success');
      $state.reload();
    }).catch(err => {
      messages.error(err);
    });
  };

  $scope.vendorSettings = {
    list: [],
    selected: {
      id: $scope.integrations.parts_authority_vendor_id,
      company_name: $scope.integrations.parts_authority_vendor_name,
    },
    search (typed) {
      return streamSearch.search('vendors', typed).then(vendors => {
        return $scope.vendorSettings.list.concat(vendors);
      });
    },
    new () {
      Vendor.quickAdd().then(vendor => {
        messages.show($translate.instant('JS_SPACE.INTEGRATIONS.SUPPLIER_FOR_INTEGRATION', { name: 'Parts Authority' }), 'success');

        $scope.integrations.parts_authority_vendor_id   = vendor.id;
        $scope.integrations.parts_authority_vendor_name = vendor.company_name;
        $scope.vendorSettings.selected                  = vendor;
      });
    },
    choose (vendor) {
      $scope.integrations.parts_authority_vendor_id   = vendor.id;
      $scope.integrations.parts_authority_vendor_name = vendor.company_name;
    },
    format (vendor) {
      return vendor ? vendor.company_name: '';
    },
    templateUrl: VendorSearchResultsHtml
  };
}
